<form
  *ngIf="formInitialized"
  [formGroup]="form"
  (ngSubmit)="onSubmit()"
  class="p-fluid">
  <div class="grid">
    <app-form-field-wrapper
      [colSize]="6"
      [label]="'Name'"
      [name]="'name'"
      [formField]="form.get('name')">
      <input
        pInputText
        id="name"
        type="text"
        formControlName="name"
        class="p-input" />
    </app-form-field-wrapper>
    <app-form-field-wrapper [colSize]="6">
      <p-dropdown
        [group]="true"
        optionLabel="name"
        (onChange)="copyColorsToForm($event)"
        [options]="colorsetTemplateOptions">
        <ng-template pTemplate="selectedItem" let-selectedOption>
          <span class="flex gap-3">
            <i class="fas fa-paste"></i> Farben aus Vorlage übertragen
          </span>
        </ng-template>
        <ng-template let-group pTemplate="group">
          <div class="flex align-items-center gap-2 text-color-secondary">
            <i [class]="group.icon"></i>
            <span>{{ group.label }}</span>
          </div>
        </ng-template>
        <ng-template let-colorset pTemplate="item">
          <div class="flex align-items-center gap-2">
            <app-colors [colorset]="colorset"></app-colors>
            <div>{{ colorset.name }}</div>
          </div>
        </ng-template>
      </p-dropdown>
    </app-form-field-wrapper>
  </div>

  <p-divider></p-divider>
  <div class="grid align-items-end">
    <div class="col-fixed flex gap-0 align-items-center">
      <button
        pButton
        type="button"
        label="Farbe hinzufügen"
        icon="fas fa-plus-circle"
        severity="success"
        [style]="{ 'border-radius': '2rem 0 0 2rem' }"
        (click)="addColor()"></button>
      <p-dropdown
        class="icon-dropdown in-group-right"
        [options]="store.allColors()"
        (onChange)="addColor($event.value)">
        <ng-template pTemplate="selectedItem" let-selectedOption
          ><i class="fas fa-palette"></i
        ></ng-template>
        <ng-template let-item pTemplate="item">
          <div class="inline-flex align-items-end">
            <i class="fas fa-circle" [style.color]="item"></i>
          </div>
        </ng-template>
      </p-dropdown>
    </div>
    <div class="col-fixed">
      <button
        type="button"
        pButton
        class="p-button-rounded p-button-danger"
        (click)="removeColor(colorsFormArray.length - 1)">
        <i class="fas fa-trash p-button-icon-left"></i>
        <span class="p-button-label">Farbe löschen</span>
      </button>
    </div>

    <app-form-field-wrapper
      class="ml-auto"
      [colSize]="'fixed'"
      [hideLabel]="true">
      <p-colorPicker
        [ngModelOptions]="{ standalone: true }"
        [(ngModel)]="baseColor"></p-colorPicker>
    </app-form-field-wrapper>
    <app-form-field-wrapper [colSize]="1" [label]="'Basisfarbe'">
      <input
        [ngModelOptions]="{ standalone: true }"
        [(ngModel)]="baseColor"
        pInputText
        type="text"
        class="p-input" />
    </app-form-field-wrapper>
    <app-form-field-wrapper
      [label]="'Anzahl der Farben'"
      [name]="'numberOfColors'"
      [colSize]="1">
      <input
        [ngModelOptions]="{ standalone: true }"
        [(ngModel)]="numberOfColors"
        pInputText
        type="text"
        class="p-input" />
    </app-form-field-wrapper>
    <app-form-field-wrapper [label]="'Schema'" [colSize]="2">
      <p-dropdown
        [ngModelOptions]="{ standalone: true }"
        [(ngModel)]="colorScheme"
        [options]="colorsetSchemes"
        optionLabel="name"
        optionValue="key"
        dataKey="key"></p-dropdown>
    </app-form-field-wrapper>
    <div class="col-fixed">
      <button
        type="button"
        pButton
        class="p-button-rounded p-button-primary"
        (click)="generateColorset()">
        <i class="fas fa-magic-wand-sparkles p-button-icon-left"></i>
        <span class="p-button-label">generieren</span>
      </button>
    </div>
  </div>

  <p-divider></p-divider>

  <div class="grid" formArrayName="colors">
    <div
      class="col-2"
      *ngFor="let colorControl of colorsFormArray.controls; let i = index"
      [formGroupName]="i">
      <p-contextMenu
        appendTo="body"
        [target]="cm"
        (onShow)="setContextMenuItems(i)"
        [model]="contextMenuItems" />
      <div class="grid" #cm pTooltip="Rechtsklick zum löschen" showDelay="500">
        <app-form-field-wrapper [colSize]="4" [hideLabel]="true">
          <p-colorPicker
            [ngModelOptions]="{ standalone: true }"
            [(ngModel)]="colorControl.value.hex"
            (ngModelChange)="
              colorControl.get('hex')?.setValue($event)
            "></p-colorPicker>
        </app-form-field-wrapper>
        <app-form-field-wrapper
          [label]="'Hex-Code'"
          [name]="'hex'"
          [colSize]="7">
          <input
            formControlName="hex"
            name="hex"
            pInputText
            type="text"
            class="p-input" />
        </app-form-field-wrapper>
      </div>
    </div>
  </div>

  <p-divider></p-divider>

  <app-form-footer
    [cancelLevel]="1"
    [hideCancelLink]="disableCancelLink"
    [showRemoveButton]="!!itemToEdit"
    [isEditMode]="!!itemToEdit"
    (removeClick)="
      itemToEdit ? confirm(undefined, itemToEdit, itemToEdit.name) : undefined
    "></app-form-footer>
</form>
